module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
var fontService = require('FontService').default;

var size = fontService.getFontSizes();
var fonts = fontService.getFonts();
var types = [
	{ name:'Push Button', value: 'push'},
	{name:'Rectangular Mouse Over Button', value: 'rectMouseOver'},
	{name:'Rounded Mouse Over Button', value: 'roundMouseOver'}
];
var radius = [0, 2, 4, 6, 8, 10, 15, 20];
var hideONReports = factoryKey ==='reports_frame'?'display: none' : '';

    ; __append("\r\n<div class=\"prop-header\"><span class=\"prop-label\">Buttons</span></div>\r\n<div class=\"row prop-detail\">\r\n\r\n    <div class=\"row themeTextRows\">\r\n \r\n        <div class=\"col-md-4 prop-sublabel\">Style</div>\r\n        <div class=\"col-md-8 nopadding-l nopadding-r\">\r\n            <select name=\"buttonStyle\" style=\"width: 90%\" id=\"buttonStyle\"> \r\n                ")
    ;  for (var i = 0; i < types.length; i++) { 
    ; __append("\r\n                    <option value=\"")
    ; __append(escapeFn(types[i].value))
    ; __append("\">\r\n                        ")
    ; __append(escapeFn(types[i].name))
    ; __append("\r\n                    </option>\r\n                ")
    ;  }; 
    ; __append("\r\n            </select>\r\n        </div>\r\n    </div>\r\n\r\n    <div class=\"row themeTextRows\">\r\n        <div class=\"col-md-4 prop-sublabel\">Text</div>\r\n        <div class=\"col-md-8 nopadding\">\r\n            <input id=\"buttonText\" name=\"buttonTextColor\" type=\"color\" value=\"")
    ; __append(escapeFn( buttonTextColor ))
    ; __append("\" style=\"width: 20px; border: 1px solid #aaaaaa; padding: 0px; height: 23px;\" />\r\n            <input id=\"buttonTextColor\" name=\"buttonTextColor\" type=\"text\" maxlength=\"7\" class=\"color-picker-text\" value=\"")
    ; __append(escapeFn( buttonTextColor ))
    ; __append("\" />\r\n\r\n            <select name=\"buttonFont\" class=\"style-font\"  id=\"buttonFont\">\r\n                \r\n            </select>\r\n\r\n            <select name=\"buttonFontSize\" id=\"buttonFontSize\" class=\"style-font-size\">\r\n                ")
    ;  for (var i = 0; i < size.length; i++) { 
    ; __append("\r\n                <option value=\"")
    ; __append(escapeFn(size[i]))
    ; __append("\">")
    ; __append(escapeFn(size[i]))
    ; __append("</option>\r\n                ")
    ;  }; 
    ; __append("\r\n                <option></option>\r\n            </select>\r\n\r\n            <img id=\"buttonTextBold\" class=\"weightSelectorButton\" name=\"buttonTextWeight\" title=\"Bold\" src=\"")
    ; __append( require('editor/icons/bold-23.png') )
    ; __append("\" style=\"background-color: ")
    ; __append(escapeFn( buttonTextWeightSelection ))
    ; __append("\" />\r\n            <img id=\"buttonTextItalic\" class=\"styleSelectorButton\" name=\"buttonTextStyle\" title=\"Italic\" src=\"")
    ; __append( require('editor/icons/italic-23.png') )
    ; __append("\"  style=\"background-color: ")
    ; __append(escapeFn( buttonTextStyleSelection ))
    ; __append("\" />\r\n        </div>\r\n    </div>\r\n\r\n    <div class=\"row themeTextRows\" style=\"")
    ; __append(escapeFn(hideONReports ))
    ; __append("\">\r\n        <div class=\"col-md-4 prop-sublabel\">Text (Over)</div>\r\n        <div class=\"col-md-8 nopadding\">\r\n            <input id=\"buttonTextOver\" name=\"buttonTextOverColor\" type=\"color\" value=\"")
    ; __append(escapeFn( buttonTextOverColor ))
    ; __append("\" style=\"width: 20px; border: 1px solid #aaaaaa; padding: 0px; height: 23px;\" />\r\n            <input id=\"buttonTextOverColor\" name=\"buttonTextOverColor\" type=\"text\" maxlength=\"7\" class=\"color-picker-text\" value=\"")
    ; __append(escapeFn( buttonTextOverColor ))
    ; __append("\" />\r\n        </div>\r\n    </div>\r\n\r\n    <div class=\"row themeTextRows\" style=\"")
    ; __append(escapeFn(hideONReports ))
    ; __append("\">\r\n        <div class=\"col-md-4 prop-sublabel\">Text (Down)</div>\r\n        <div class=\"col-md-8 nopadding\">\r\n            <input id=\"buttonTextDown\" name=\"buttonTextDownColor\" type=\"color\" value=\"")
    ; __append(escapeFn( buttonTextDownColor ))
    ; __append("\" style=\"width: 20px; border: 1px solid #aaaaaa; padding: 0px; height: 23px;\" />\r\n            <input id=\"buttonTextDownColor\" name=\"buttonTextDownColor\" type=\"text\" maxlength=\"7\" class=\"color-picker-text\" value=\"")
    ; __append(escapeFn( buttonTextDownColor ))
    ; __append("\" />\r\n        </div>\r\n    </div>\r\n\r\n    <div class=\"row themeTextRows\">\r\n        <div class=\"col-md-4 prop-sublabel\">Background</div>\r\n        <div class=\"col-md-8 nopadding\">\r\n            <input id=\"buttonBg\" name=\"buttonBgColor\" type=\"color\" value=\"")
    ; __append(escapeFn( buttonBgColor ))
    ; __append("\" style=\"width: 20px; border: 1px solid #aaaaaa; padding: 0px; height: 23px;\" />\r\n            <input id=\"buttonBgColor\" name=\"buttonBgColor\" type=\"text\" maxlength=\"7\" class=\"color-picker-text\" value=\"")
    ; __append(escapeFn( buttonBgColor ))
    ; __append("\" />\r\n\r\n            <input id=\"buttonBgGradient\" name=\"buttonBgGradientColor\" type=\"color\" value=\"")
    ; __append(escapeFn( buttonBgGradientColor ))
    ; __append("\" style=\"width: 20px; border: 1px solid #aaaaaa; padding: 0px; height: 23px;\" />\r\n            <input id=\"buttonBgGradientColor\" name=\"buttonBgGradientColor\" type=\"text\" maxlength=\"7\" class=\"color-picker-text\" value=\"")
    ; __append(escapeFn( buttonBgGradientColor ))
    ; __append("\" />\r\n        </div>\r\n    </div>\r\n\r\n    <div class=\"row themeTextRows\" style=\"")
    ; __append(escapeFn(hideONReports ))
    ; __append("\">\r\n        <div class=\"col-md-4 prop-sublabel\">Background (Over)</div>\r\n        <div class=\"col-md-8 nopadding\">\r\n            <input id=\"buttonBgOver\" name=\"buttonBgOverColor\" type=\"color\" value=\"")
    ; __append(escapeFn( buttonBgOverColor ))
    ; __append("\" style=\"width: 20px; border: 1px solid #aaaaaa; padding: 0px; height: 23px;\" />\r\n            <input id=\"buttonBgOverColor\" name=\"buttonBgOverColor\" type=\"text\" maxlength=\"7\" class=\"color-picker-text\" value=\"")
    ; __append(escapeFn( buttonBgOverColor ))
    ; __append("\" />\r\n\r\n            <input id=\"buttonBgGradientOver\" name=\"buttonBgGradientOverColor\" type=\"color\" value=\"")
    ; __append(escapeFn( buttonBgGradientOverColor ))
    ; __append("\" style=\"width: 20px; border: 1px solid #aaaaaa; padding: 0px; height: 23px;\" />\r\n            <input id=\"buttonBgGradientOverColor\" name=\"buttonBgGradientOverColor\" type=\"text\" maxlength=\"7\" class=\"color-picker-text\" value=\"")
    ; __append(escapeFn( buttonBgGradientOverColor ))
    ; __append("\" />\r\n        </div>\r\n    </div>\r\n\r\n    <div class=\"row themeTextRows\" style=\"")
    ; __append(escapeFn(hideONReports ))
    ; __append("\">\r\n        <div class=\"col-md-4 prop-sublabel\">Background (Down)</div>\r\n        <div class=\"col-md-8 nopadding\">\r\n            <input id=\"buttonBgDown\" name=\"buttonBgDownColor\" type=\"color\" value=\"")
    ; __append(escapeFn( buttonBgDownColor ))
    ; __append("\" style=\"width: 20px; border: 1px solid #aaaaaa; padding: 0px; height: 23px;\" />\r\n            <input id=\"buttonBgDownColor\" name=\"buttonBgDownColor\" type=\"text\" maxlength=\"7\" class=\"color-picker-text\" value=\"")
    ; __append(escapeFn( buttonBgDownColor ))
    ; __append("\" />\r\n\r\n            <input id=\"buttonBgGradientDown\" name=\"buttonBgGradientDownColor\" type=\"color\" value=\"")
    ; __append(escapeFn( buttonBgGradientDownColor ))
    ; __append("\" style=\"width: 20px; border: 1px solid #aaaaaa; padding: 0px; height: 23px;\" />\r\n            <input id=\"buttonBgGradientDownColor\" name=\"buttonBgGradientDownColor\" type=\"text\" maxlength=\"7\" class=\"color-picker-text\" value=\"")
    ; __append(escapeFn( buttonBgGradientDownColor ))
    ; __append("\" />\r\n        </div>\r\n    </div>\r\n\r\n    <div class=\"row themeTextRows\">\r\n        <div class=\"col-md-4 prop-sublabel\">Corner Radius</div>\r\n        <div class=\"col-md-8 nopadding\">\r\n            <select name=\"buttonRadius\" id=\"buttonRadius\" class=\"style-font\">\r\n                ")
    ;  for (var i = 0; i < radius.length; i++) { 
    ; __append("\r\n                <option value=\"")
    ; __append(escapeFn(radius[i]))
    ; __append("\">")
    ; __append(escapeFn(radius[i]))
    ; __append("</option>\r\n                ")
    ;  }; 
    ; __append("\r\n                <option></option>\r\n            </select>\r\n        </div>\r\n    </div>\r\n\r\n</div>")
  }
  return __output;

}